<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="student"></HeaderRow>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/student">学员优作</el-breadcrumb-item>
						<el-breadcrumb-item to="/studentList">{{ breadcrumb }}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="content">
					<div class="list">
						<div class="item" v-for="(item,index) in list" :key="`item_${item.article_id}`"
							@click="gotoStDetail(item.article_id)">
							<p class="name">
								<span>{{ item.title }}</span>
								<span>{{ item.student }}</span>
							</p>
							<p v-if="!((index+1)%4)" class="line"></p>
						</div>
					</div>
					<div class="watching">
						<div class="title">
							<i class="el-icon-thumb"></i>
							<span>大家都在看</span>
						</div>
						<div class="subList">
							<div class="subItem" v-for="sub in suggest" :key="`sub_${sub.article_id}`"
								@click="gotoStDetail(sub.article_id)">
								<p><span>{{ sub.title }}</span></p>
							</div>
						</div>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import FooterRow from "@/components/footerRow.vue";
	import HeaderRow from "@/components/headerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,

		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>